module.exports = __webpack_public_path__ + "img/gmsqgmdw_down.41e1922c.png";